// https://docs.google.com/spreadsheets/d/1MRuCaYhxeD7rzIQj5OcuRqyvlekkfVZE1pFeRZ0aNY8/edit?gid=1396517525#gid=1396517525
export const uniqueValuesFixed: string[] = [
  "Ab Aeterno|1",
  "Adonia's Ego|40",
  "Aerisvane's Wings|2",
  "Against the Darkness|100000",
  "Alkem Eira|1",
  "Alpha's Howl|100",
  "Amor Mandragora|1",
  "Andvarius|50",
  "Apep's Supremacy|1",
  "Apron of Emiran|1",
  "Arakaali's Gift|1",
  "Arvil's Wheel|1",
  "Ashrend|1",
  "Asphyxia's Wrath|20",
  "Assailum|1",
  "Astramentis|200",
  "Atsak's Sight|1",
  "Atziri's Acuity|50",
  "Atziri's Contempt|40",
  "Atziri's Disdain|1",
  "Atziri's Rule|40",
  "Atziri's Splendour|150000",
  "Atziri's Step|1",
  "Aurseize|50",
  "Beacon of Azis|1",
  "Beetlebite|1",
  "Beira's Anguish|5",
  "Belly of the Beast|1",
  "Beyond Reach|1",
  "Bijouborne|1",
  "Birth of Fury|1",
  "Birthright Buckle|1",
  "Bitterbloom|1",
  "Black Sun Crest|1",
  "Blackbraid|10",
  "Blackflame|1",
  "Blackgleam|1",
  "Blackheart|2",
  "Blistering Bond|1",
  "Blood of the Warrior|1",
  "Blood Price|2",
  "Bloodbarrier|2",
  "Blueflame Bracers|1",
  "Bones of Ullr|100",
  "Brain Rattler|1",
  "Bramblejack|1",
  "Breath of the Mountains|1",
  "Briarpatch|1",
  "Briskwrap|1",
  "Bristleboar|1",
  "Bronzebeard|1",
  "Brynhand's Mark|1",
  "Bursting Decay|100000",
  "Bushwhack|1",
  "Byrnabas|1",
  "Cadiro's Gambit|150",
  "Calgyra's Arc|1",
  "Call of the Brotherhood|5",
  "Candlemaker|1",
  "Carnage Heart|2",
  "Carrion Call|1",
  "Chainsting|1",
  "Chernobog's Pillar|2",
  "Chober Chaber|1",
  "Choir of the Storm|1000",
  "Clear Skies|1",
  "Cloak of Defiance|10",
  "Cloak of Flame|5",
  "Coat of Red|1",
  "Collapsing Horizon|1000",
  "Constricting Command|50",
  "Controlled Metamorphosis|150",
  "Cornathaum|40",
  "Corona of the Red Sun|1",
  "Corpsewade|1",
  "Cospri's Will|2",
  "Couture of Crimson|2",
  "Coward's Legacy|2",
  "Cracklecreep|1",
  "Crest of Ardura|30",
  "Crown of Eyes|40",
  "Crown of the Pale King|1",
  "Crown of the Victor|10",
  "Crown of Thorns|1",
  "Cruel Hegemony|1",
  "Cursecarver|1",
  "Daevata's Wind|1",
  "Darkness Enthroned|50",
  "Darkray Vectors|1",
  "Death Articulated|10000",
  "Death Rush|1",
  "Death's Harp|2",
  "Deathblow|1",
  "Deathrattle|1",
  "Defiance of Destiny|150",
  "Deidbell|1",
  "Demigod's Virtue|1",
  "Demon Stitcher|1",
  "Dionadair|1",
  "Doedre's Damning|2",
  "Doedre's Tenure|1",
  "Doomfletch|10",
  "Doomgate|1",
  "Doryani's Prototype|2",
  "Double Vision|1",
  "Dreadfist|1",
  "Dream Fragments|30",
  "Drillneck|1",
  "Dunkelhalt|1",
  "Dusk Vigil|1",
  "Dustbloom|1",
  "Earthbound|1",
  "Edyrn's Tusks|1",
  "Effigy of Cruelty|20",
  "Elevore|1",
  "Empire's Grasp|1",
  "Enezun's Charge|1",
  "Enfolding Dawn|2",
  "Erian's Cobble|1",
  "Essentia Sanguis|20",
  "Evergrasping Ring|5",
  "Eye of Chayula|1",
  "Ezomyte Peak|1",
  "Fairgraves' Curse|1",
  "Feathered Fortress|1",
  "Fireflower|20",
  "Fixation of Yix|2",
  "Flesh Crucible|20000",
  "Font of Power|1",
  "For Utopia|40",
  "Forsaken Bangle|10",
  "Foxshade|1",
  "Freedom of Faith|50",
  "From Nothing|100",
  "Frostbreath|1",
  "Fury of the King|50",
  "Gamblesprint|1",
  "Ghostmarch|1",
  "Ghostwrithe|10",
  "Gifts from Above|20",
  "Glimpse of Chaos|75",
  "Gloamgown|1",
  "Gloomform|1",
  "Glowswarm|1",
  "Goldrim|10",
  "Goregirdle|5",
  "Grand Spectrum|2000",
  "Gravebind|10",
  "Greed's Embrace|100",
  "Greymake|2",
  "Grip of Kulemak|1",
  "Grip of Winter|1",
  "Guiding Palm of the Eye|150",
  "Guiding Palm of the Heart|150",
  "Guiding Palm of the Mind|150",
  "Hand of Wisdom and Action|20",
  "Hateforge|5000",
  "Headhunter|1500",
  "Heart of the Well|5000",
  "Heartbound Loop|1",
  "Heatshiver|2",
  "Heroic Tragedy|2000",
  "Hinekora's Sight|1",
  "Hoghunt|1",
  "Horns of Bynden|2",
  "Hrimnor's Hymn|5",
  "Husk of Dreams|1",
  "Hyrri's Ire|100",
  "Hysseg's Claw|1",
  "Icefang Orbit|1",
  "Icetomb|1",
  "Idle Hands|15",
  "Idol of Uldurn|2",
  "Igniferis|1",
  "Indigon|10",
  "Ingenuity|1000",
  "Innsmouth|1",
  "Irongrasp|1",
  "Ironride|1",
  "Jarngreipr|1",
  "Kalandra's Touch|50",
  "Kaltenhalt|1",
  "Kaom's Heart|75",
  "Keelhaul|1",
  "Keeper of the Arc|1",
  "Killjoy|2",
  "Kingsguard|1",
  "Kitoko's Current|1",
  "Lavianga's Spirits|50",
  "Leer Cast|1",
  "Legionstride|1",
  "Leopold's Applause|5",
  "Levinstone|10",
  "Lifesprig|1",
  "Lightning Coil|2",
  "Ligurium Talisman|1",
  "Lioneye's Glare|15",
  "Lochtonial Caress|1",
  "Luminous Pace|2",
  "Lycosidae|1",
  "Mahuxotl's Machination|5",
  "Maligaro's Virtuosity|40",
  "Marohi Erqi|5",
  "Mask of the Sanguimancer|2",
  "Mask of the Stitched Demon|2",
  "Matsya|2",
  "Megalomaniac|5000",
  "Meginord's Girdle|2",
  "Melting Maelstrom|100",
  "Merit of Service|2",
  "Midnight Braid|1",
  "Mind of the Council|10",
  "Ming's Heart|1",
  "Mist Whisper|1",
  "Mjölner|100",
  "Morior Invictus|200",
  "Murkshaft|2",
  "Myris Uxor|30",
  "Nascent Hope|15",
  "Nazir's Judgement|1",
  "Nebuloch|5",
  "Necromantle|1",
  "Ngamahu's Chosen|1",
  "Nightscale|2",
  "Nocturne|1",
  "Northpaw|2",
  "Oaksworn|1",
  "Obern's Bastion|1",
  "Olroth's Resolve|100000",
  "Olrovasara|1",
  "Original Sin|40",
  "Painter's Servant|1",
  "Palm of the Dreamer|20000",
  "Pariah's Embrace|1",
  "Perandus Seal|1",
  "Perfidy|2",
  "Pillar of the Caged God|1",
  "Plaguefinger|30",
  "Polcirkeln|1",
  "Powertread|5",
  "Pragmatism|10",
  "Prayers for Rain|1",
  "Prism Guardian|5",
  "Prism of Belief|100000",
  "Prized Pain|1",
  "Quatl's Molt|1",
  "Quecholli|10",
  "Queen of the Forest|10",
  "Quill Rain|2",
  "Radiant Grief|1",
  "Rampart Raptor|1",
  "Rathpith Globe|2000",
  "Rearguard|1",
  "Redblade Banner|2",
  "Redflare Conduit|1",
  "Revered Resin|1",
  "Rise of the Phoenix|1",
  "Rite of Passage|100000",
  "Rondel de Ezo|1",
  "Rondel of Fragility|1",
  "Ryslatha's Coil|15",
  "Sacred Flame|2000",
  "Sacrosanctum|5",
  "Saffell's Frame|1",
  "Saitha's Spear|5",
  "Sands of Silk|50",
  "Sandstorm Visage|2000",
  "Sanguine Diviner|1",
  "Sanguis Heroum|2",
  "Scold's Bridle|5",
  "Sculpted Suffering|1",
  "Season of the Hunt|15",
  "Seed of Cataclysm|50",
  "Seeing Stars|1",
  "Sekhema's Resolve|200",
  "Serpent's Egg|5",
  "Serpent's Lesson|1",
  "Shackles of the Wretched|30",
  "Shankgonne|2",
  "Shavronne's Satchel|10",
  "Shyaba|1",
  "Sierran Inheritance|10",
  "Silks of Veneration|10",
  "Silverthorne|1",
  "Sine Aequo|1000",
  "Sire of Shards|1",
  "Skin of the Loyal|15",
  "Skysliver|15",
  "Slivertongue|1",
  "Snakebite|1",
  "Snakepit|30",
  "Solus Ipse|5",
  "Soul Mantle|1",
  "Soul Tether|50",
  "Spire of Ire|15",
  "Splinter of Lorrata|1",
  "Splinterheart|1",
  "Starkonja's Head|1",
  "Stone of Lazhwar|1",
  "Strugglescream|300",
  "Sunsplinter|20",
  "Surefooted Sigil|1",
  "Svalinn|15",
  "Tabula Rasa|40",
  "Tangletongue|2",
  "Taryn's Shiver|1",
  "Temporalis|5000000",
  "Tetzlapokal's Desire|2",
  "The Adorned|1000000",
  "The Anvil|1",
  "The Barrow Dweller|1",
  "The Black Cat|2",
  "The Black Doubt|1",
  "The Black Insignia|1",
  "The Blood Thorn|1",
  "The Brass Dome|40",
  "The Bringer of Rain|10",
  "The Burden of Leadership|1",
  "The Burden of Shadows|2",
  "The Burrower|1",
  "The Changing Seasons|1",
  "The Coming Calamity|5",
  "The Covenant|200",
  "The Dancing Mirage|1",
  "The Dark Defiler|1",
  "The Desperate Alliance|10000",
  "The Devouring Diadem|1",
  "The Empty Roar|1",
  "The Eternal Spark|1",
  "The Everlasting Gaze|1",
  "The Fall of the Axe|30",
  "The Flesh Poppet|2",
  "The Gnashing Sash|300000",
  "The Grand Project|50",
  "The Hammer of Faith|20",
  "The Hollow Mask|1",
  "The Infinite Pursuit|1",
  "The Knight-errant|1",
  "The Last Flame|5000000",
  "The Last Lament|10",
  "The Lethal Draw|1",
  "The Mutable Star|1",
  "The Pandemonius|1",
  "The Peacemaker's Draught|1",
  "The Prisoner's Manacles|1",
  "The Rat Cage|1",
  "The Road Warrior|1",
  "The Searing Touch|75",
  "The Sentry|1",
  "The Smiling Knight|1",
  "The Surrender|1",
  "The Three Dragons|1",
  "The Unborn Lich|15",
  "The Vertex|4000",
  "The Vile Knight|1",
  "The Whispering Ice|40",
  "The Wicked Quill|1",
  "Thief's Torment|2",
  "Threaded Light|20",
  "Thrillsteel|10",
  "Thunderfist|15",
  "Tidebreaker|1",
  "Titanrot Cataphract|1",
  "Trampletoe|15",
  "Treefingers|2",
  "Trenchtimbre|15",
  "Trephina|1",
  "Tyranny's Grip|1",
  "Umbilicus Immortalis|1",
  "Undying Hate|5000",
  "Unforeseen Consequences|200",
  "Ungil's Harmony|1",
  "Valako's Roar|1",
  "Valako's Vice|1",
  "Veil of the Night|10",
  "Venopuncture|1",
  "Ventor's Gamble|40",
  "Vigilant View|1",
  "Vis Mortis|1",
  "Visage of Ayah|1",
  "Visions of Paradise|500",
  "Voll's Protector|2",
  "Voltaxic Rift|15",
  "Waistgate|2",
  "Wake of Destruction|1",
  "Wandering Reliquary|1",
  "Wanderlust|10",
  "Waveshaper|1",
  "Whisper of the Brotherhood|1",
  "Widow's Reign|1",
  "Widowhail|10",
  "Window to Paradise|1",
  "Windscream|30",
  "Wings of Caelyn|1",
  "Winter's Bite|1",
  "Wondertrap|1",
  "Wraeclast Besieged|2",
  "Wulfsbane|1",
  "Xoph's Blood|1",
  "Yoke of Suffering|30",
  "Yriel's Fostering|1",
  "Zerphi's Genesis|1",
  "Zerphi's Serape|1000",

  // Uniques

  "Berek's Grip|2",
  "Berek's Pass|5",
  "Berek's Respite|1",
  "Brutus' Lead Sprinkler|15",
  "Cat O' Nine Tails|1",
  "Decree of Acuity|2",
  "Decree of Flight|25",
  "Decree of Loyalty|1",
  "Duality|20",
  "Eshtera's Path|5000",
  "Eventide Petals|25",
  "Eyes of the Runefather|5",
  "Facebreaker|50",
  "Forgotten Warden|5",
  "Geofri's Sanctuary|1",
  "Horror's Flight|2000",
  "Immaculate Adherence|50",
  "Ironbound|1",
  "Liminal Coil|1500",
  "Mageblood|5000",
  "Mastered Domain|3",
  "Nightfall|2000",
  "Opportunity|2",
  "Redemption|500",
  "Periphery|500",
  "Sadist's Mercy|150",
  "Safrin's Resolve|5000",
  "Serle's Grit|1",
  "Spiteful Floret|1",
  "Split Personality|2000",
  "Surge of the Tide|1",
  "Sylvan's Effigy|250",
  "The Auspex|200",
  "The Hollow Mask|1",
  "The Ordained|1500",
  "The Raven's Flock|5000",
  "The Sunken Vessel|1",
  "The Unleashed|10",
  "Twisted Empyrean|250",
  "Vestige of Darkness|10",
  "Veilpiercer|25",
  "Voices|1000",
  "Zaida's Longevity|200",
  "Uhtred's Chalice|25",
  "Loreweave|100",
  "Runeseeker's Call|50000",
  "The Taming|1000",
  "Bluetongue|50000",
  "Redbeak|50000",
  "The Dancing Dervish|50000",
  "The Master's Reach|2000",
]
